import { useState, useEffect } from 'react';
import style from './footer.module.css';

function Footer()
{
    return (
        <div className={style.footer}>
            <p>ИП Попов Владислав Евгеньевич</p>
            <p>ИНН: 346100913190</p>
            <p>ОГРНИП: 322344300006615</p>
            <p>г. Волгоград, Улица Кирова 121А</p>
            <p>winxy.ru@yandex.ru</p>
        </div>
    );
}
export default Footer;